// extracted by mini-css-extract-plugin
module.exports = {"postLink":"PostSummary_postLink__3mHyQ","subtitle":"PostSummary_subtitle__3LgwA","title":"PostSummary_title__2God_","img":"PostSummary_img__EhG_k"};